var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopWinners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#EBC2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 17.6172C5.8 17.6172 2.38281 14.2 2.38281 10C2.38281 5.8 5.8 2.38281 10 2.38281C14.2 2.38281 17.6172 5.8 17.6172 10C17.6172 14.2 14.2 17.6172 10 17.6172Z",
    fill: "#C785EB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cent_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5859 9.45563V7.13898C11.2598 7.30434 11.7578 7.73793 11.7578 8.23633C11.7578 8.5602 12.0199 8.82227 12.3438 8.82227C12.6676 8.82227 12.9297 8.5602 12.9297 8.23633C12.9297 7.10422 11.9218 6.15766 10.5859 5.94V5.30664C10.5859 4.98277 10.3239 4.7207 10 4.7207C9.67613 4.7207 9.41406 4.98277 9.41406 5.30664V5.94C8.07816 6.15766 7.07031 7.10422 7.07031 8.23633C7.07031 9.36844 8.07816 10.315 9.41406 10.5327V12.8493C8.74016 12.6839 8.24219 12.2504 8.24219 11.752C8.24219 11.4281 7.98012 11.166 7.65625 11.166C7.33238 11.166 7.07031 11.4281 7.07031 11.752C7.07031 12.8841 8.07816 13.8306 9.41406 14.0483V14.6873C9.41406 15.0112 9.67613 15.2733 10 15.2733C10.3239 15.2733 10.5859 15.0112 10.5859 14.6873V14.0483C11.9218 13.8306 12.9297 12.8841 12.9297 11.752C12.9297 10.6198 11.9218 9.67324 10.5859 9.45563ZM8.24219 8.23633C8.24219 7.73793 8.74016 7.30434 9.41406 7.13898V9.33367C8.74016 9.16828 8.24219 8.73469 8.24219 8.23633ZM10.5859 12.8493V10.6546C11.2598 10.82 11.7578 11.2536 11.7578 11.752C11.7578 12.2504 11.2598 12.6839 10.5859 12.8493Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopWinners);
export default __webpack_public_path__ + "static/media/icon_top_winners.5b0acc2000dd9f0bf3170256cfc18562.svg";
export { ForwardRef as ReactComponent };